export default "__VITE_ASSET__47a32fe2__"